import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { AuthenicationService } from '../../_services/authenication.service';
import { DoctorService } from '../../_services/doctor.service';

import { ToasterService } from '../../_services/toaster.service';

import {environment} from '../../../environments/environment';

import * as moment from 'moment';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-appointment-detail',
  templateUrl: './appointment-detail.component.html',
  styleUrls: ['./appointment-detail.component.css']
})
export class AppointmentDetailComponent implements OnInit {
  userdetaild: string;
  baseUrl: string = environment.baseUrl;
  doctorid: string;
  returnUrl: string;
  id: string;
  appointment_detail: any[] = [];
  sessions: any[] = [];

  constructor(private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private doctorservice: DoctorService, private toaster: ToasterService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }
    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';



    this.id = this.route.snapshot.params.id;
    const payload = {
      id: this.id
    };
    this.getAppointmentById(payload);
  }

  getAppointmentById(id) {
    this.doctorservice.getAppointmentById(id)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            data.DoctorAppointment.map(appointment=>{
              appointment.credits_data.map(credit=>{
                credit.plan_expiry_date = credit.plan_expiry_date ? Intl.DateTimeFormat('en-GB', {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true}).format(new Date(credit.plan_expiry_date)) : null;
              })
            });
            this.appointment_detail = data.DoctorAppointment[0];
            // console.log(this.appointment_detail);

          } else {
            this.toaster.showError('Appointment Detail', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Appointment Detail', error.error.ResponseMessage);
        });
  }

calculateDays(startDate,endDate) {
   let start_date = moment(startDate, 'YYYY-MM-DD HH:mm:ss');
   let end_date = moment(endDate, 'YYYY-MM-DD HH:mm:ss');
   let duration = moment.duration(end_date.diff(start_date));
   let hours = duration.asHours();
   return hours;
}

  async cancelAppointment(sData) {

    let checkGiftData = false;
    let remainingDatas = null;
    if (sData.coupon_code !== '') {
      const userEmail = {
        user_email: sData['clientid']['users_email'],
        promocode: sData.coupon_code
      };
        remainingDatas = await this.checkPromoCode(userEmail);
        checkGiftData = await this.checkGiftPromoCode('Appointment',sData.coupon_code);
    }

    let str;
    let eligible;
    let date = sData['scheduleId']['date'];
    let time = sData['scheduleId']['start_time'];
    const dateFormat = "YYYY-MM-DD HH:mm:ss";
    let appdate = date + 'T' + time + ':00';
    let rightNow = moment().format(dateFormat);//now
    let appointmentDate = moment(appdate).format(dateFormat);

    let differenceInHours = this.calculateDays(rightNow,appointmentDate);
    // console.log('output',output);

    // const differenceInHours = moment(appointmentDate).diff(rightNow, 'hours');
    // console.log(differenceInHours);
    if (differenceInHours > 24) {
      str = 'Are you sure to Cancel Appointment';
      eligible = true;
    } else {
      str = 'You are trying to cancel the appointment within 24 hours. So, you will not receive any refund. Are you sure to Cancel Appointment.';
      eligible = false;
    }

    if (confirm(str)) {

      const payload = {
        appointmentId: sData._id,
        status: '2',
        cancel_date: rightNow,
        cancel_by: 'admin',
        is_eligible_for_refund: eligible
      };
      this.spinnerService.show();
      this.doctorservice.updateStatus(payload)
        .subscribe(
          async (data: any) => {
            if (data && data.ResponseCode === '200') {

              if (eligible == true) {
                if (checkGiftData == false) {
                  if (remainingDatas !== null) {

                    if (sData.coupon_code == remainingDatas.promocode) {
                      console.log('check');
                      if (sData.coupon_code == 'MP80') {
                          await this.refundAmount(sData);
                      }else{
                        await this.refundSession(sData,remainingDatas);
                      }
                      // await this.refundSession(sData,remainingDatas);
                      this.toaster.showSuccess('Appointment', 'Appointment cancelled successfully');
                    }else{
                      console.log('check1');
                      await this.refundAmount(sData);
                      this.toaster.showSuccess('Appointment', 'Appointment cancelled successfully');
                    }
                  }else{
                    console.log('check2');
                    await this.refundAmount(sData);
                    this.toaster.showSuccess('Appointment', 'Appointment cancelled successfully');
                  }
                }
                else{
                  await this.refundSession(sData,remainingDatas);
                  await this.refundGiftSession(sData.coupon_code,sData['clientid']['users_email']);
                  this.toaster.showSuccess('Appointment', 'Appointment cancelled successfully');
                }



              }else{
                this.spinnerService.hide();
                this.toaster.showSuccess('Appointment', 'Appointment cancelled successfully');
                this.reloadComponent();

              }

              const sessionpayload = {
                clientid: sData['clientid']['_id']
              };
              this.getPatientSessions(sessionpayload);

            } else {
              console.log('Appointments', data.ResponseMessage);
              this.spinnerService.hide();
            }
            // this.router.navigate([this.returnUrl]);
          },
          error => {
            console.log('Doctor', error);
            this.spinnerService.hide();
          });
      }
    };


    async cancelAppointmentNew(sData) {
      this.spinnerService.show();
      let eligible;
      let str = '';
      let date = sData['scheduleObj']['date'];
      let time = sData['scheduleObj']['start_time'];
      const dateFormat = "YYYY-MM-DD HH:mm:ss";
      let appdate = date + 'T' + time + ':00';
      let rightNow = moment().format(dateFormat);//now
      let appointmentDate = moment(appdate).format(dateFormat);

      // const differenceInHours = moment(appointmentDate).diff(rightNow, 'hours');
      const differenceInHours = this.calculateDays(rightNow,appointmentDate);
      if (differenceInHours > 24) {
        str = 'Are you sure to Cancel Appointment';
        eligible = true;
      } else {
        str = 'You are trying to cancel the appointment within 24 hours. So, you will not receive any refund. Are you sure to Cancel Appointment.';
        eligible = false;
      }
      if (confirm(str)) {
        const payload = {
          appointmentId: sData._id,
          status: '2',
          cancel_date: rightNow,
          cancel_by: 'admin',
          is_eligible_for_refund: eligible,
          sData: sData,
        };

        this.doctorservice.cancelAppointment(payload)
          .subscribe(
            async (data: any) => {
              if (data && data.ResponseCode === '200') {
                this.spinnerService.hide();
                this.toaster.showSuccess('Appointment', 'Appointment cancelled successfully');
                this.reloadComponent();
              } else {
                this.spinnerService.hide();
                this.toaster.showWarning('Appointment', data.ResponseMessage);
              }
            },
            error => {
              this.spinnerService.hide();
              this.toaster.showError('Appointment', error);
            });
      }



    };


    async checkPromoCode(data){
      return this.doctorservice.checkRemainingSession(data)
        .toPromise()
        .then(data => {
          if (data && data.ResponseCode === '200') {
            let total = data.Data.length;

            return data.Data[total - 1];
            //console.log(this.remainingData);
          }
          else{
            return null;
          }
        })
        .catch(err => {
          return undefined;
        })
    };

    async checkGiftPromoCode(type,promocode){
      const payload = {type: type, promocode: promocode};
      return this.doctorservice.getPromoCodeByCode(payload)
        .toPromise()
        .then(data => {
          if (data && data.ResponseCode === '200') {
            let prmoocodeData = data.promoCodeList[0];
            return (prmoocodeData['for_gift'])?prmoocodeData['for_gift']:false;
          }
          else{
            return false;
          }
        })
        .catch(err => {
          return false;
        })
    };

    async refundGiftSession(promocode,email){
          const payload1 = {
            receiver_email: email,
            promocode: promocode
          };
          this.addGiftCodeRemaining(payload1);
    };

    addGiftCodeRemaining(payload) {
      this.doctorservice.addGiftCodeRemaining(payload)
        .subscribe(
          (data: any) => {
            this.spinnerService.hide();
            this.reloadComponent();
            console.log('book',data);
          },
          error => {
            this.spinnerService.hide();
            this.reloadComponent();
            console.log('book',error);
          });
    };

    async refundSession(sData,remainingDatas){
          const payload1 = {
            user_email: sData['clientid']['users_email'],
            promocode: remainingDatas.promocode,
            next_free_session_or_event: remainingDatas.next_free_session_or_event,
            remaining: remainingDatas.remaining,
            total_session_remaining: remainingDatas.total_session_remaining+1,
            type: remainingDatas.type
          };
          this.addUsedCode(payload1);
    }

    async refundAmount(sData){
      if(sData.coupon_code !== '') {
          if (sData.coupon_code == 'MP80') {
            if (sData.payment_status == 'captured') {
              if (sData.payment_details[0].id != undefined) {
                  this.processPaymentRefund(sData.payment_details[0].id,sData._id);
              }
              else{
                this.spinnerService.hide();
              }
            }
            else{
              this.spinnerService.hide();
            }
          }
          else{
            this.spinnerService.hide();
          }
      }else{
        if (sData.payment_details[0].id != undefined) {
            this.processPaymentRefund(sData.payment_details[0].id,sData._id);
        }
        else{
          this.spinnerService.hide();
        }
      }
    }

    addUsedCode(payload) {
      this.doctorservice.addUsedCode(payload)
        .subscribe(
          (data: any) => {
            console.log('book',data);
            this.spinnerService.hide();
            this.reloadComponent();
          },
          error => {
            console.log('book',error);
            this.spinnerService.hide();
            this.reloadComponent();
          });
    }

    processPaymentRefund(payment_id,id) {
        const payload = {
          payment_id: payment_id,
          id: id
        };
        this.doctorservice.processPaymentRefund(payload)
          .subscribe(
            (data: any) => {
              if (data && data.ResponseCode === '200') {
              console.log('Refund',data.ResponseMessage);
              this.spinnerService.hide();
              this.reloadComponent();
              } else {
                console.log('Refund', data.ResponseMessage);
                this.spinnerService.hide();
                this.reloadComponent();
              }
            },
            error => {
              console.log('Refund', error);
              this.spinnerService.hide();
              this.reloadComponent();
            });

    }

    getPatientSessions(payload) {
      this.doctorservice.getUserAppointment(payload)
        .subscribe(
          (data: any) => {

            if (data && data.ResponseCode === '200') {
              this.sessions = data.ClientAppointment.reverse();
             // console.log(this.sessions);
            } else {
              //alert(data.ResponseMessage);
              console.log('no data found');
            }

          },
          error => {
            console.log('Doctor', error.error.ResponseMessage);
          });
    }

    reloadComponent() {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([`appointment-detail/${this.id}`]);
    }

    getDate(date){
      return new Date(date).toLocaleDateString();
    }

    gettime(date){
      return new Date(date).toLocaleTimeString();
    }

}
